module.exports = __webpack_public_path__ + "img/icon.463a8977.png";